import {connect} from 'react-redux';
import Entry from './Entry.jsx';
import {
  handlePaymentLogSelection,
  handlePrintEntryClick,
  handlePrintPaymentLogClick,
  handleEntrySelectChecked,
  handleSquadChangeClick,
  handleEventChangeClick
} from './actions';
import {
  handleViewRosterClick,
  handleManageRosterClick
} from '../shared/actions';

const mapStateToProps = (state, props) => ({
  showCalculatedDivisionToCaptain: state.registration.base.showCalculatedDivisionToCaptain,
  allowChangeBetweenFreeEvents: state.registration.base.allowChangeBetweenFreeEvents,
  ...props
});

const mapDispatchToProps = dispatch => ({
  onViewRosterClick: entryId => dispatch(handleViewRosterClick(entryId)),
  onManageRosterClick: entryId => dispatch(handleManageRosterClick(entryId)),
  onPaymentLogClick: entryId => dispatch(handlePaymentLogSelection(entryId)),
  onPrintEntryClick: entryId => dispatch(handlePrintEntryClick(entryId)),
  onPrintPaymentLogClick: entryId => dispatch(handlePrintPaymentLogClick(entryId)),
  onSelectChecked: entryId => dispatch(handleEntrySelectChecked(entryId)),
  onSquadChangeClick: (entryId, squadDateTime) => dispatch(handleSquadChangeClick(entryId, squadDateTime)),
  onEventChangeClick: (entryId, squadDateTime) => dispatch(handleEventChangeClick(entryId, squadDateTime))
});

export default connect(mapStateToProps, mapDispatchToProps)(Entry);



// WEBPACK FOOTER //
// ./src/features/registration/manage/EntryContainer.jsx